module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"「{prevLevelName}」を終了しました！","message":"パスポートにスタンプが追加されました！"},"en":{"title":"{prevLevelName} Completed!","message":"A New Stamp Was Added to Your Passport."}}')
  delete Component.options._Ctor
}
